<template>
  <a-modal
    :title="$t('reportForms.edit')"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="close"
    :cancelText="$t('reportForms.close')">
    <a-spin :spinning="confirmLoading">
      <a-form>
        <a-form-item :label="$t('reportForms.vipExpireTimeLabel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            v-model="formData.vipOverTime"
            format="YYYY-MM-DD HH:mm:ss"
            allow-clear/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { updateVipTime } from '@/api/biz/user'
import moment from 'moment'

export default {
  name: 'UpdateVipTimeForm',
  components: {

  },
  props: {

  },
  data() {
    return {
      formData: {
        vipOverTime: null
      }, // 表单数据
      visible: false, // 弹窗显示控制
      confirmLoading: false, // 提交后加载, 防止短时间内重复提交

      labelCol: { xs: { span: 24 }, sm: { span: 5 } }, // 表单项标签宽度配置
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } } // 表单项内容宽度配置
    }
  },
  methods: {
    /**
     * 外部方法, 外部调用此方法 打开编辑表单
     * @param {*} record 数据
     */
    audit(record) {
      // 如果 record.vipOverTime 是字符串，转换为 moment 对象
      if (record.vipOverTime && typeof record.vipOverTime === 'string') {
        this.formData = {
          ...record,
          vipOverTime: moment(record.vipOverTime)
        }
      } else {
        this.formData = { ...record }
      }
      this.confirmLoading = false
      this.visible = true
    },

    /**
     * 关闭表单, 触发 close 事件
     */
    close() {
      this.$emit('close')
      this.visible = false
      // 重置表单数据
      this.formData = {
        vipOverTime: null
      }
    },
    /**
     * 提交
     */
    handleOk() {
      this.confirmLoading = true

      // 准备提交的数据，将 moment 对象转换为字符串格式
      const submitData = {
        ...this.formData
      }

      // 如果 vipOverTime 是 moment 对象，转换为字符串格式 "YYYY-MM-DD HH:mm:ss"
      if (submitData.vipOverTime && moment.isMoment(submitData.vipOverTime)) {
        submitData.vipOverTime = submitData.vipOverTime.format('YYYY-MM-DD HH:mm:ss')
      } else if (submitData.vipOverTime && typeof submitData.vipOverTime === 'object' && submitData.vipOverTime.format) {
        // 兼容其他日期对象
        submitData.vipOverTime = moment(submitData.vipOverTime).format('YYYY-MM-DD HH:mm:ss')
      } else if (!submitData.vipOverTime) {
        // 如果没有选择日期，设置为 null
        submitData.vipOverTime = null
      }

      // 只发送必要的字段给后端
      const requestData = {
        vipOverTime: submitData.vipOverTime
      }

      // 包含用户ID（后端可能需要）
      if (this.formData.id) {
        requestData.id = this.formData.id
      } else if (this.formData.userId) {
        requestData.userId = this.formData.userId
      }

      console.log('提交的数据:', requestData)

      updateVipTime(requestData).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.close()
          this.$emit('ok')
        } else {
          this.$message.warning(res.message)
        }
      }).catch(error => {
        console.error('更新会员到期时间失败:', error)
        this.$message.error(this.$t('reportForms.updateFailed'))
      }).finally(() => {
        this.confirmLoading = false
      })
    }
  }
}
</script>
<style lang='less' scoped></style>
